import { render } from "./FailureView.vue?vue&type=template&id=129b8504&scoped=true"
const script = {}

import "./FailureView.vue?vue&type=style&index=0&id=129b8504&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129b8504"]])

export default __exports__